export { validateIndonesianPhoneNumber } from "./phoneNumberValidation";
export { validateEmail } from "./emailValidation";
export { alert } from "./alert";


// WEBPACK FOOTER //
// ./src/utils/index.js